var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styles from "./DistributionLevel.module.scss";
var DistributionLevel = function (_a) {
    var levels = _a.levels, colors = _a.colors, leadersScoreBelowTarget = _a.leadersScoreBelowTarget, isProjectSingleSelect = _a.isProjectSingleSelect, pageType = _a.pageType;
    var count = levels.filter(function (level) { return level > 0; }).length;
    var dividedWidth = 100 / count;
    var levelSum = levels.reduce(function (accumilator, level) { return accumilator + level; }, 0);
    return (_jsxs("div", __assign({ style: { width: "100%" }, className: styles.distributionLevelFactorScore }, { children: [_jsx("div", __assign({ "data-testid": "distributionLevelFactorScore", className: styles.distributionLevelFactorScoreContainer }, { children: levels.map(function (level, index) {
                    var _a, _b, _c;
                    if (level <= 0) {
                        return null;
                    }
                    var style = {
                        width: "".concat(dividedWidth * level, "%"),
                        borderRadius: "4px",
                        height: "24px",
                        textAlign: "center",
                        backgroundColor: ((_a = colors[index]) === null || _a === void 0 ? void 0 : _a.color) || "white",
                        color: ((_b = colors[index]) === null || _b === void 0 ? void 0 : _b.text) || "black",
                        border: "1px solid ".concat(((_c = colors[index]) === null || _c === void 0 ? void 0 : _c.border) || "black"),
                        fontSize: "12px",
                        lineHeight: "24px",
                        fontFamily: "var(--font-stack-full-regular)",
                    };
                    return !levelSum ? (_jsx(_Fragment, {})) : (_jsx("div", __assign({ style: style }, { children: Math.round((level / levelSum) * 100) }), index));
                }) })), isProjectSingleSelect && pageType && (_jsxs("div", __assign({ className: styles.distributionBelowText }, { children: [Math.round(leadersScoreBelowTarget), "% of leaders scored below target."] })))] })));
};
export default DistributionLevel;
